const firebaseConfig = {
    apiKey: "AIzaSyCJ-rIEyFQIqRkV4wMjOk382oPRgw8bqco",
    authDomain: "myb-travel.firebaseapp.com",
    projectId: "myb-travel",
    storageBucket: "myb-travel.appspot.com",
    messagingSenderId: "584990199339",
    appId: "1:584990199339:web:91204dbe6ab39fb8ece46e"
};

export default firebaseConfig;